import React, { useEffect, useRef, useState } from 'react'
import {Services} from '../../network/Services';
import AddNewUser from '../AddNewUser';
import PaymentForm from '../CommonComponents/Paymentform';
import SearchDropdown from '../CustomComponent';
import SearchBar from '../CommonComponents/SearchBar';
import { formatToUS } from '../../control/Constant';
import SearchableSelect from '../CustomSelect';

const Agingoptions = ({paymentData,setPaymentData,setSelectedUserData,setuseLoader,resetToCompanySelection,setToast,isUpdated}) => {
  const [userList,setUserlist] = useState([])
  const [searchText,setSearchtext] = useState('')
  const [selectedUser,setSelecteduser] = useState({fullName: '',primaryEmail: '',primaryMobile: ''})
  const [businessLines,setBusinessLines] = useState([])
  const [showData,setShowdata] = useState(false)
  const [showDropdown, setShowDropdown] = useState(false);
  const [results, setResults] = useState([]);
  const [showUserForm, setshowUserForm] = useState(false)
  let isClient = JSON.parse(sessionStorage.getItem('isClient'));
  const [showConfirm, setShowConfirm] = useState(false);
  let confirmResolveRef = useRef(null);

  useEffect(()=>{
    getSubscriptionBysubtenantfunc()
  },[])


   useEffect(() => {
     let sessionSubtenantId = sessionStorage.getItem('SubtenantId');
     let SessPrimaryUserId = sessionStorage.getItem('SessPrimaryUserId');
     let isOtpVarified = JSON.parse(sessionStorage.getItem('isOtpVarified'));
     if (isOtpVarified == true) {
       let inputData = {
         pageNumber: 1,
         rowsOfPage: 40,
         searchingText: null,
         subtenantId: sessionSubtenantId,
       };
       fetchUserData(inputData, SessPrimaryUserId)

     }
   }, [isUpdated])



   const fetchUserData = (json, id) => {
     setuseLoader(true)
     Services?.GetClientDetailsByUserId(json, id).then((res) => {
       setSearchData(res.data?.data[0])

       setuseLoader(false)
     })
       .catch((err) => {
         setuseLoader(false)
         console.error(err);
       });
   };

  const getSubscriptionBysubtenantfunc = () => {
    setuseLoader(true)
    let getSubscriptionBysubtenantpromise = Services.getSubscriptionBysubtenant('3')
    getSubscriptionBysubtenantpromise.then((res)=>{
      // console.log(res,'resgetSubscriptionBysubtenantfunc')
      setBusinessLines(res.data.data)
      setuseLoader(false)
    }).then((err)=>{
      console.log(err,'err')
      setuseLoader(false)
    })
  }

  useEffect(()=>{
    updateUserId()
  },[selectedUser?.userId])

  const updateUserId = () => {
    if(selectedUser?.userId != null || selectedUser?.userId != undefined){
    handleInputChange('clientInfo',selectedUser?.userId)
    }
  }

    const handleSearch = async () => {
    if (!searchText.trim()){
    // setshowUserForm(false)
    return;}

    let inputData = {
        "subtenantId": 3,
        "userType": "ALLCLIENT",
        "searchtext": searchText || null,
        // "roleId":18
    }
    setuseLoader(true)
    Services?.getUserListByRoleIdservice(inputData).then((res) => {
    if(res?.data) {
      console.log('User76567data:', res.data?.data);
      setResults(res.data?.data || []);
      setShowDropdown(true);
      setuseLoader(false)
      if(res?.data?.data?.length == 0){
        setResults([]);
        setshowUserForm(true)
        setSelecteduser(() => ({
          fullName: '',
          primaryEmail: '',
          primaryMobile: '',
        }));
        setShowDropdown(false);
      }
    }
    }).catch((error) => {
      setResults([]);
      setShowDropdown(false);
      setuseLoader(false)
    });};

    const setSearchData =(data)=>{
    setUserlist(data)
    const {fullName,primaryEmail,primaryMobile,matNo,userId,memberName,primaryEmailAddress,primaryPhoneNumber,memberId} = data
      setSelecteduser((prev) => ({
        ...prev,
        memberId:userId || memberId,
        fullName: fullName || memberName,
        primaryEmail: primaryEmail || primaryEmailAddress,
        primaryMobile: primaryMobile || primaryPhoneNumber,
      }));
      setSelectedUserData((prev) => ({
        ...prev,
        memberId:userId || memberId,
        fullName: fullName || memberName,
        primaryEmail: primaryEmail || primaryEmailAddress,
        primaryMobile: primaryMobile || primaryPhoneNumber,
      }))
      setshowUserForm(true)
      setSearchtext(data.matNo);
      setShowDropdown(false);
    }

    const runApis = (data) => {
    if (!data?.trim()) return;
    let inputData = {
        "subtenantId": 3,
        "userType": "ALLCLIENT",
        "searchtext": data ||  null,
        // "roleId":18
    }

    setuseLoader(true)
    Services?.getUserListByRoleIdservice(inputData).then((res) => {
      if (res?.data) {
        setResults(res.data?.data || []);
        setShowDropdown(true);
        setuseLoader(false)
        if(res?.data?.data?.length == 0){
              setshowUserForm(true)
              setSelectedUserData()
        }
      }
    }).catch((error) => {
        setResults([]);
        setshowUserForm(true)
        setShowDropdown(false);
        setuseLoader(false)
    });
    }

    const onChangeBusiness = (e) => {
      // console.log(e,"eeeeeeeee")
      const value = e;
      const selectedName = businessLines?.find((s)=>{return s.subscriptionId == e}).subscriptionName;
      setPaymentData(prev => ({
        ...prev,
        lineOfBusiness: value,
        'serviceName': selectedName
      }));
    }

    const updateUser = (data, formJson, timeMatter)=>{
     const {createdBy,emailId,firstName,id,isUserActive,lastName,contactStatus,servicePlanId,signUpPlatform,userActivationMode,userId,userName} = data?.data?.data
     let inputData = {
            fName :firstName,
            lName: lastName ?? '',
            mName: "",
            isPrimary: true,
            subtenantId : 3,
            updatedBy: createdBy,
            contactStatus: contactStatus,
            userId: userId,
            memberRelationship: null}
    setuseLoader(true)
    const updateUser = Services?.upateMemberByuserID(inputData)
      updateUser.then((res)=>{
        setuseLoader(false)
      get_UserData(emailId)
      }).catch((err)=>{
        setuseLoader(false)
      })
  }

  const get_UserData =(emailId)=>{
    let inputData = {
        "subtenantId": 3,
        "userType": "ALLCLIENT",
        "searchtext": emailId || null,
        // "roleId":18
    }
    setuseLoader(true)
    Services?.getUserListByRoleIdservice(inputData).then((res) => {
      if (res?.data) {
        console.log('User76567data:', res.data?.data);
        setResults(res.data?.data || []);

        setSearchData(res.data.data[0])
        // setShowDropdown(true);
        setuseLoader(false)

      }
    }).catch((error) => {
        setResults([]);
        setShowDropdown(false);
         setuseLoader(false)
    });
  }

  const productFunc = (e) => {
    console.log(e,"fdfkdjkdjfkdfkd", e.target.value)
    handleInputChange('productType', e.target.value)
  }

  useEffect(()=>{
        handleInputChange('description', '')
  },[paymentData?.productType,paymentData?.lineOfBusiness])

  const addUserbtn = () => {
    setshowUserForm(true)
    setSelecteduser(() => ({
      fullName: '',
      primaryEmail: '',
      primaryMobile: '',
    }));
    setSelectedUserData((prev) => ({
      ...prev,
      memberId:'',
      fullName: '',
      primaryEmail: '',
      primaryMobile: '',
    }))
  }




// function formatToUS(value) {
//   const cleaned = String(value).replace(/,/g, "");
//   const number = parseFloat(cleaned);
//   return isNaN(number) ? "" : number.toLocaleString("en-US");
// }


  const handleInputChange = (field, e) => {
    setPaymentData({...paymentData,[field]: e});
  }

    console.log(searchText,"searchText",selectedUser,"showUserForm",showUserForm)
    console.log(paymentData,"paymentDatapaymentData","businessLines",businessLines)

  const handleBeforeOpen = () => {
    return new Promise((resolve) => {
      if (window.isEditClicked) {
        confirmResolveRef.current = resolve;
        setShowConfirm(true);
      } else {
        resolve(true);
      }
      if (window.isViewOnlyMode && window.isViewOnlyMode()) {
        resolve(true);
        return;
      }
      const details = window.getUserDetails ? window.getUserDetails() : {};
      const isEmpty = Object.values(details).every(
        (val) => val === "" || val === null || val === undefined
      );
      if (isEmpty) {
        resolve(true);
        return;
      }
      if (typeof window.setEditClickGlobal === "function") {
        confirmResolveRef.current = resolve;
        setShowConfirm(true);
      } else {
        resolve(true);
      }
    });
  };

  const handleSave = () => {
    if (typeof window.isEditClicked !== "undefined" && !window.isEditClicked) {
      if (typeof window.addUserGlobal === "function") {
        window.addUserGlobal();
      }
    } else {
      if (typeof window.handleSaveGlobal === "function") {
        window.handleSaveGlobal();
      }
    }
    confirmResolveRef.current(false);
    setShowConfirm(false);
  };

  const handleDiscard = () => {
    if (typeof window.handleCancelGlobal === "function") {
      window.handleCancelGlobal();
    }
    confirmResolveRef.current(false);
    setShowConfirm(false);
  };

    return (
        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow-md py-6">
          {/* <SearchDropdown userList={userList} setSelecteduser={setSelecteduser} /> */}
          {isClient !== true && <div className="grid grid-cols-2 align-items-center">
            <SearchBar reference="Agingoption" showDropdown={showDropdown} setMatterNumber={setSearchtext} matterNumber={searchText} handleSearch={handleSearch} results={results} setSearchData={setSearchData} runApis={runApis} />
            <div className="w-[10%] h-[40px] mt-3">
              <h3 className="text-lg font-semibold mb-5"></h3>
              <button
                className="w-full h-full bg-blue-600 text-white rounded-md hover:bg-blue-700 mt-5 flex items-center justify-center"
                onClick={() => addUserbtn()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 5v14M5 12h14"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>}
          {(showUserForm == true ) && <AddNewUser reference="agingoption" setSelecteduser={setSelecteduser} selectedUser={selectedUser} updateUser={updateUser} setToast={setToast} />}
          </div>
          {/* Line of Business */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-lg font-semibold mb-4">Line of Business*</h3>
            {/* <select
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              value={paymentData?.lineOfBusiness}
              onChange={(e) => onChangeBusiness(e)}
            >
              <option value="">Select Business Line</option>
              {businessLines?.length > 0 && businessLines?.map(({subscriptionId, subscriptionName}) => (
                <option key={subscriptionId} value={subscriptionId}>{subscriptionName}</option>
              ))}
            </select> */}
                      <SearchableSelect
                      // label="New -Service Type- Billed For"
                      value={paymentData.lineOfBusiness}
                      options={businessLines}
                      optionLabel={(o) => o.subscriptionName}
                      optionValue={(o) => o.subscriptionId}
                      onChange={(value) => onChangeBusiness(value)}
                      // disabled={isNotValidNullUndefile(paymentData.userAuthSubId) ? true : isServiceLocked ? true : false}
                      placeholder={`Select Business Line`}
                      beforeOpen={handleBeforeOpen}
                    />
          </div>
          {/* Products Details */}
          {(paymentData.lineOfBusiness == '10' || paymentData.lineOfBusiness == '11') && (
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold mb-4">{paymentData.lineOfBusiness == 10 ? 'Product' : 'WorkShops'} Details</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {paymentData.lineOfBusiness == 10 ? 'Product' : 'WorkShops'} Type
                  </label>
                  {console.log(paymentData,"paymentData.productType")}
                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    value={paymentData.productType || ''}
                    onChange={(e) => productFunc(e)}
                  >
                    <option value="" disabled>Select {paymentData.lineOfBusiness == 10 ? 'Product' : 'WorkShops'} Type</option>
                    {businessLines?.filter((e)=>{return e.subscriptionId == paymentData?.lineOfBusiness})[0]?.subscriptionSubTypes?.map((subs)=>(<option value={subs.subscriptionSubTypeId}>{subs.subscriptionSubTypeName}</option>))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Description
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    value={paymentData.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    placeholder="Product description..."
                  />
                </div>
              </div>
            </div>
          )}
          {/* Workshop Details */}
          {/* {paymentData.lineOfBusiness === '11' && (
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold mb-4">Workshop Details</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Workshop Type
                  </label>
                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    value={paymentData.workshopType || ''}
                    onChange={(e) => handleInputChange('workshopType', e.target.value)}
                  >
                    <option value="">Select Workshop Type</option>
                    {Object.entries(workshopTypes).map(([id, name]) => (
                      <option key={id} value={id}>{name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Workshop Name
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    value={paymentData.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    placeholder="Workshop name..."
                  />
                </div>
              </div>
            </div>
          )} */}
          {/* Guided Planning Details */}
          {paymentData.lineOfBusiness == '12' && (
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold mb-4">Guided Planning Components</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {businessLines?.filter((e)=>{return e.subscriptionId == paymentData?.lineOfBusiness})[0]?.subscriptionSubTypes?.map(({subscriptionSubTypeId, subscriptionSubTypeName}) => (
                  <div key={subscriptionSubTypeId} className="flex items-center space-x-3">
                    <input
                      type="checkbox"
                      id={subscriptionSubTypeId}
                      onChange={(e) => {
                        const value = e.target.value;
                        const checked = e.target.checked;
                        const existingComponents = Array.isArray(paymentData?.components)
                          ? paymentData?.components
                          : [];
                        const filteredComponents = existingComponents?.filter(
                          (c) => c.subsSubTypeId !== value
                        );
                        const updatedComponents = [
                          ...filteredComponents,
                          {
                            subsSubTypeId: value,
                            checked: checked,
                          },
                        ];
                        handleInputChange('components', updatedComponents);
                      }}
                      value={subscriptionSubTypeId}
                    />
                    <label htmlFor={subscriptionSubTypeId} className="text-sm">{subscriptionSubTypeName}</label>
                  </div>
                ))}
              </div>
              {Array.isArray(paymentData?.components) && paymentData?.components?.filter((e)=>{return e?.subsSubTypeId == 12 || e?.subsSubTypeId == '12'})[0]?.checked == true && (
                <div className="mt-4">
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    placeholder="Describe other component..."
                    value={paymentData?.otherDescription || ''}
                    onChange={(e) => handleInputChange('otherDescription', e.target.value)}
                  />
                </div>
              )}
            </div>
          )}
          {/* Amount */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-lg font-semibold mb-4">Payment Amount</h3>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500">$</span>
              </div>
              <input
                type="text"
                className="pl-7 pr-4 py-2 w-full border border-gray-300 rounded-md"
                value={formatToUS(paymentData?.amount) || ''}
                placeholder="0"
                // min="0"
                // step="1"
                onChange={(e) => {
                  // const onlyNumbers = e.target.value.replace(/[^\d.,]/g, '');
                  handleInputChange('amount', e.target.value);
                }}
                onFocus={async (e) => !(await handleBeforeOpen()) && e.target.blur()}
              />
            </div>
          </div>
          <PaymentForm handleBeforeOpen={handleBeforeOpen} paymentData={paymentData} handleInputChange={handleInputChange} setPaymentData={setPaymentData} paymentDateDisable={false} paymentFrom={"Agingoptions"}/>
          {showConfirm && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
                <h2 className="text-xl font-semibold text-gray-800">Confirm Save</h2>
                <p className="mt-3 text-gray-600">
                  Would you like to save before continuing?
                </p>
                <div className="mt-6 flex justify-end gap-3">
                  <button onClick={handleSave} className="px-4 py-2 rounded-lg bg-green-600 text-white">
                    Save
                  </button>
                  <button onClick={handleDiscard} className="px-4 py-2 rounded-lg bg-green-600 text-white">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      );
}

export default Agingoptions
